import FaqList from './faq-list';

import '../css/main.css';

window.addEventListener('DOMContentLoaded', () => {
	const faqContainers = document.querySelectorAll('.faq-container');

	faqContainers.forEach(container => {
		const dtElements = container.getElementsByTagName('dt');
		const ddElements = container.getElementsByTagName('dd');

		const faqList = new FaqList(dtElements, ddElements);

		faqList.init();
	});
});